// extracted by mini-css-extract-plugin
export default {"contentWrapper":"SIgnInProcessStep_contentWrapper__rLS5i","pageDescription":"SIgnInProcessStep_pageDescription__YmY01"};